<template>
  <div class="modal animated fadeIn faster" :id="id">
    <div class="modal-background"></div>
    <div class="modal-card" :style="`${width.length > 0 ? 'width:' + width : ''}`">
      <header class="modal-card-head is-bg-primary" style="border: none; border-top-left-radius: .3rem; border-top-right-radius: .3rem;">
        <p class="modal-card-title has-text-white" v-html="title" style="margin-right: 10px;"></p>
        <button class="delete" aria-label="close"></button>
      </header>
      <section class="modal-card-body animated fadeIn" style="border-bottom-left-radius: .3rem; border-bottom-right-radius: .3rem;">
        <slot></slot>
      </section>
    </div>
  </div>
</template>

<script>
import modal from "~/utils/modal";

export default {
  props: {
    id: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: () => 'Modal Title'
    },
    width: {
      type: String,
      default: () => ''
    },
  },

  mounted() {
    this.bindModal();
  },

  updated() {
    this.bindModal();
  },

  methods: {
    bindModal() {
      modal.bind();
    }
  }
}
</script>
